import React, { useEffect, useState } from "react";
import { Table, Empty, Row, Col, Divider, Tabs } from "antd";
import {
  BarsOutlined,
  MenuUnfoldOutlined,
  RollbackOutlined,
} from "@ant-design/icons";
import { useHistory, Link } from "react-router-dom";
import moment from "moment";
import RequestHandler from "util/RequestHandler";
import { ColumnHelper } from "../../util/TableHelper";
import { useMediaQuery } from "react-responsive";
import { odata, queryHelper } from "../../routes/Filters/Helper/index";
import FirmTransactionListTableFilter from "../Filters/FirmTransactionListTableFilter";

const FirmTransactionsList = (props) => {
  const history = useHistory();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [firmId, setFirmId] = useState(props.match.params.firmId);
  const [currencyId, setCurrencyId] = useState(1);
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [currencyTabList, setCurrencyTabList] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [balance, setBalance] = useState("0,00 ₺");
  const [firmName, setFirmName] = useState("");
  const [firstDataGot, setFirstDataGot] = useState(false);

  useEffect(() => {
    if (firstDataGot) {
      getTableData();
    }
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = "";
    const { skip, take, filter } = tableDataQueryOptions;

    const conditions = [];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.post(
      `/FirmTransaction?&$count=true&$orderby=transactionDateValue desc${query}&$skip=${skip}&$top=${take}`,
      {
        FirmId: props.match.params.firmId,
        currencyId: currencyId,
      },
      false,
      { rawResponse: true }
    ).then((res) => {
      if (res.status == 200) {
        setTableData({
          data: res.data.value,
          total: res.data["@odata.count"],
          loading: false,
        });
        if (res.data["@odata.count"] > 0 && skip === 0) {
          setBalance(res.data.value.at(0).balanceString);
        }
      } else {
        setTableData({
          data: [],
          total: 0,
          loading: false,
        });
      }
    });
  };
  useEffect(() => {
    RequestHandler.get(
      `/FirmTransaction/GetFirmCurrencies/${props.match.params.firmId}?$orderby=id`
    ).then((response) => {
      setCurrencyTabList(response);
      setFirstDataGot(true);

      let query = "";
      const { skip, take, filter } = tableDataQueryOptions;

      const conditions = [];
      if (filter) {
        conditions.push(filter);
      }

      if (conditions.length > 0) {
        query = `&$filter=${conditions.join(" and ")}`;
      }

      RequestHandler.post(
        `/FirmTransaction?&$count=true&$orderby=transactionDateValue desc${query}&$skip=${skip}&$top=${take}`,
        {
          FirmId: props.match.params.firmId,
          currencyId: response.length != 0 ? response.at(0).id : 0,
        },
        false,
        { rawResponse: true }
      ).then((res) => {
        if (res.status == 200) {
          setTableData({
            data: res.data.value,
            total: res.data["@odata.count"],
            loading: false,
          });
          if (res.data["@odata.count"] > 0) {
            setBalance(res.data.value.at(0).balanceString);
          }
        } else {
          setTableData({
            data: [],
            total: 0,
            loading: false,
          });
        }
      });
    });
  }, []);

  useEffect(() => {
    RequestHandler.get(
      `/Firm/GetByIdWithPassive/${props.match.params.firmId}`
    ).then((response) => {
      setFirmName(response.name);
    });
  }, []);

  const columns = [
    {
      title: "İşlem Tarihi",
      dataIndex: "transactionDate",
      key: "transactionDate",
      align: "left",
    },
    {
      title: "İşlem Tipi",
      dataIndex: "processTypeName",
      key: "processTypeName",
      align: "left",
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return text.substring(0, 25).length < 25
          ? text.substring(0, 25) + ""
          : text.substring(0, 25) + "...";
      },
    },
    {
      title: "Gerçekleşen Tutar",
      dataIndex: "transactionAmountString",
      key: "transactionAmountString",
      align: "center",
      align: "left",
      render: (text, row, index) => {
        {
          return <div style={{ width: 98, whiteSpace: "nowrap" }}>{text}</div>;
        }
      },
    },
    {
      title: "Planlanan Tutar",
      dataIndex: "planAmountString",
      key: "planAmountString",
      align: "left",
      render: (text, row, index) => {
        {
          return <div style={{ width: 98, whiteSpace: "nowrap" }}>{text}</div>;
        }
      },
    },
    {
      title: "Bakiye",
      dataIndex: "balanceString",
      key: "balanceString",
      align: "left",
      render: (text, row, index) => {
        {
          return <div style={{ width: 98, whiteSpace: "nowrap" }}>{text}</div>;
        }
      },
    },
  ];

  const dataStateChange = (e) => {
    setTableData(e);
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
    setCurrencyId(tabKey);
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { ...prevState, skip: 0, current: 1, filter: query };
    });
  };

  return (
    <div>
      <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> GERİ DÖN
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>
      <Row id="titleArea">
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> CARİ HAREKETLERİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}></Col>
      </Row>
      <Row>
        <Col span={12} style={{ textAlign: "start", fontSize: 19 }}>
          <p>{firmName}</p>
        </Col>
        <Col span={12} style={{ textAlign: "end", fontSize: 19 }}>
          <p>Proje Bakiye : {balance}</p>
        </Col>
      </Row>
      <FirmTransactionListTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Tabs defaultActiveKey={1} onChange={onTabChange}>
        {currencyTabList.length == 0 && (
          <>
            <Tabs.TabPane tab="Tümü" key="0" />
          </>
        )}
        {currencyTabList.length !== 0 && (
          <>
            {currencyTabList.map((item) => (
              <Tabs.TabPane tab={item.code} key={item.id} />
            ))}
          </>
        )}
      </Tabs>
      <Row>
        <>
          <Col span={24}>
            <Table
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{
                overflowX: "auto",
                maxHeight: "100%",
                width: "100%",
              }}
              columns={columns}
              onDataStateChange={dataStateChange}
              dataSource={tableData.data}
              loading={tableData.loading}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
              }}
              sortable={true}
              rowKey="id"
            ></Table>
          </Col>
        </>
      </Row>
    </div>
  );
};

export default FirmTransactionsList;
